module.exports = "/_next/static/images/fad3bd6ff9fd3381f21010ca0e4c6170-challenge-the-system-lg@1x.jpg";